import { Common } from './common';

import { ImportValidation } from './models/provider';
import { ImportRow } from './models/outreachSync';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async importVerify(args: {
    feedId: string;
    practiceId: string;
    importRows: Record<string, string>[];
  }): Promise<Record<string, ImportValidation>[]> {
    const url = this.common.constructPath(`/outreach/sync/import/verify`);
    return this.common.postJSON(url, args);
  }

  async import(args: {
    feedId: string;
    feedUploadId?: string;
    practiceId: string;
    importRows: ImportRow[];
    removeFeedItems?: boolean;
    appendFeedItems?: boolean;
  }) {
    const url = this.common.constructPath(`/outreach/sync/import`);
    return this.common.postJSON(url, args);
  }
}
